'use strict';

import React from 'react';

import { useState, useContext, useMemo, useRef } from 'react';

import { Button, Form, Row, Col } from 'react-bootstrap';

import { Formik } from 'formik';
import * as yup from 'yup';

import Select from 'react-select';

import useRequest from '../helper/useRequest';

import { toast } from 'react-toastify';
import AppContext from '../AppContext';
import Separator from '../helper/Separator';

import MandatoryFieldNotice from '../helper/MandatoryFieldNotice';

import {
    email,
    emailRepeat,
    password,
    passwordRepeat,
    username,
    firstName,
    lastName,
    organisationName,
    phoneNo,
    street,
    houseNo,
    city,
    postCode,
    dataProtection,
    newsletterOptIn,
    additionToAddress,
    conditionUse
} from '../helper/Schema';

const schema = yup.object().shape({
    OrganisationName: organisationName,
    Email: email,
    Emailrepeat: emailRepeat,
    Password: password,
    Passwordrepeat: passwordRepeat,
    Username: username,
    FirstName: firstName,
    LastName: lastName,
    PhoneNo: phoneNo,
    Street: street,
    HouseNo: houseNo,
    AdditionToAddress: additionToAddress,
    City: city,
    PostCode: postCode,
    NewsletteroptIn: newsletterOptIn,
    ConditionOfUse: conditionUse,
});

function Register() {
    const { request } = useRequest();
    const handleSubmitSchool = async (values) => {
        const result = await request("/Register/RegisterSchoolUser", values);
        const json = result.data;

        if (json.r == 1) {
            window.location.replace("/Register/Finish");
        }
        else {
            toast.error(json.message);
        }
    };

    const { Salutations } = useContext(AppContext);
    const { TypesOfSchool } = useContext(AppContext);
    const [passwordShown, setPasswordShown] = useState(false);
    const togglePassword = () => {
        setPasswordShown(!passwordShown);
    };
    const formRef = useRef(null);

    const ErrorMessage = function (errors) {
        var errorList = [];
        for (var key in errors) {
            errorList.push(errors[key]);
        }
        if (errorList.length == 0) return "";
        return <div>Hat Fehler</div>;
    };

    const sortedOptions = useMemo(() => TypesOfSchool.sort((a, b) => {
        const nameA = a.Description.toUpperCase(); 
        const nameB = b.Description.toUpperCase();
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
    }).map(a => { return { value: a.TypeOfSchoolID, label: a.Description} }), [TypesOfSchool]);

    const salutationOptions = Salutations.map((a) => { return { value: a.SalutationID, label: a.Description }; });


    return (
        <Formik
            innerRef={(f) => formRef.current = f}
            validationSchema={schema}
            validateOnChange={true}
            validateOnBlur={true}
            onSubmit={(values) => {
                handleSubmitSchool(values);
            }}
            initialValues={{
                OrganisationName: '',
                TypeOfSchoolID: 2,
                Street: '',
                HouseNo: '',
                AdditionToAddress: '',
                City: '',
                PostCode: '',
                Email: '',
                Emailrepeat: '',
                Username: '',
                Password: '',
                Passwordrepeat: '',
                SalutationID: 1,
                Title: '',
                FirstName: '',
                LastName: '',
                PhoneNo: '',                
                IsSchool: true,
                NewsletterOptIn: true,
                ConditionOfUse: false
            }}
        >
            {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
            }) => (
                <Form noValidate onSubmit={handleSubmit}>
                    <Separator text="Schulinformationen" />
                    <Row>
                        <Col xs={12} lg={6}>
                            <Form.Group as={Row} className="mb-3" controlId="OrganisationName">
                                <Form.Label className="required" column sm={6}>Schulname</Form.Label>
                                <Col sm={6}>
                                    <Form.Control isInvalid={errors.OrganisationName && touched.OrganisationName} placeholder="" name="OrganisationName" value={values.OrganisationName} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.OrganisationName}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group as={Row} className="mb-3" controlId="TypeOfSchoolID" name="TypeOfSchoolID" onBlur={handleBlur} onChange={handleChange}>
                                <Form.Label className="required" column sm={6}>Schulform</Form.Label>
                                <Col sm={6}>
                                    <Select name="TypeOfSchoolID" options={sortedOptions} classNamePrefix="bv-select" className="bv-select" placeholder="Bitte auswählen" onChange={
                                        (value) => {
                                            formRef.current.setFieldValue("TypeOfSchoolID", value.value);
                                        }
                                    } />
                                </Col>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} lg={6}>
                            <Form.Group as={Row} className="mb-3" controlId="Street">
                                <Form.Label className="required" column sm={6}>Straße</Form.Label>
                                <Col sm={6}>
                                    <Form.Control isInvalid={errors.Street && touched.Street} placeholder="" name="Street" value={values.Street} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.Street}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group as={Row} className="mb-3" controlId="HouseNo">
                                <Form.Label className="required" column sm={6}>Hausnummer</Form.Label>
                                <Col sm={6}>
                                    <Form.Control isInvalid={errors.HouseNo && touched.HouseNo} placeholder="" name="HouseNo" value={values.HouseNo} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.HouseNo}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} lg={6}>
                            <Form.Group as={Row} className="mb-3" controlId="AdditionToAddress">
                                <Form.Label column sm={6}>Adresszusatz</Form.Label>
                                <Col sm={6}>
                                    <Form.Control isInvalid={errors.AdditionToAddress && touched.AdditionToAddress} placeholder="" name="AdditionToAddress" value={values.AdditionToAddress} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.AdditionToAddress}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} lg={6}>
                            <Form.Group as={Row} className="mb-3" controlId="PostCode">
                                <Form.Label className="required" column sm={6}>Postleitzahl</Form.Label>
                                <Col sm={6}>
                                    <Form.Control isInvalid={errors.PostCode && touched.PostCode} placeholder="" name="PostCode" value={values.PostCode} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.PostCode}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group as={Row} className="mb-3" controlId="City">
                                <Form.Label className="required" column sm={6}>Stadt</Form.Label>
                                <Col sm={6}>
                                    <Form.Control isInvalid={errors.City && touched.City} placeholder="" name="City" value={values.City} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.City}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} lg={6}>
                            <Form.Group as={Row} className="mb-3" controlId="PhoneNo">
                                <Form.Label className="required" column sm={6}>Telefonnummer</Form.Label>
                                <Col sm={6}>
                                    <Form.Control isInvalid={errors.PhoneNo && touched.PhoneNo} placeholder="" name="PhoneNo" value={values.PhoneNo} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.PhoneNo}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>

                        </Col>
                    </Row>
                    <Separator text="Benutzerdaten" />
                    <Row>
                        <Col xs={12} lg={6}>
                            <Form.Group as={Row} className="mb-3" controlId="SalutationID" name="SalutationID" onBlur={handleBlur} onChange={handleChange}>
                                <Form.Label className="required" column sm={6}>Anrede</Form.Label>
                                <Col sm={6}>
                                    <Select defaultValue={salutationOptions[0]} name="SalutationID" options={salutationOptions} classNamePrefix="bv-select" className="bv-select" placeholder="Bitte auswählen" onChange={
                                        (value) => {
                                            formRef.current.setFieldValue("SalutationID", value.value);
                                        }
                                    } />
                                </Col>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group as={Row} className="mb-3" controlId="Title">
                                <Form.Label column sm={6}>Titel</Form.Label>
                                <Col sm={6}>
                                    <Form.Control isInvalid={errors.Title && touched.Title} placeholder="" name="Title" value={values.Title} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.Title}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} lg={6}>
                            <Form.Group as={Row} className="mb-3" controlId="FirstName">
                                <Form.Label className="required" column sm={6}>Vorname</Form.Label>
                                <Col sm={6}>
                                    <Form.Control isInvalid={errors.FirstName && touched.FirstName} placeholder="" name="FirstName" value={values.FirstName} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.FirstName}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group as={Row} className="mb-3" controlId="LastName">
                                <Form.Label className="required" column sm={6}>Nachname</Form.Label>
                                <Col sm={6}>
                                    <Form.Control isInvalid={errors.LastName && touched.LastName} placeholder="" name="LastName" value={values.LastName} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.LastName}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} lg={6}>
                            <Form.Group as={Row} className="mb-3" controlId="Email">
                                <Form.Label className="required" column sm={6}>E-Mail-Adresse</Form.Label>
                                <Col sm={6}>
                                    <Form.Control isInvalid={errors.Email && touched.Email} placeholder="" name="Email" value={values.Email} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.Email}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group as={Row} className="mb-3" controlId="Emailrepeat" autoComplete="off">
                                <Form.Label className="required" column sm={6}>E-Mail wiederholen</Form.Label>
                                <Col sm={6}>
                                    <Form.Control isInvalid={errors.Emailrepeat && touched.Emailrepeat} placeholder="" name="Emailrepeat" value={values.Emailrepeat} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.Emailrepeat}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} lg={6}>
                            <Form.Group as={Row} className="mb-3" controlId="Username">
                                <Form.Label className="required" column sm={6}>Benutzername</Form.Label>
                                <Col sm={6}>
                                    <Form.Control isInvalid={errors.Username && touched.Username} placeholder="" name="Username" value={values.Username} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.Username}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} lg={6}>
                            <Form.Group as={Row} className="mb-3" controlId="Password" autoComplete="off">
                                <Form.Label className="required" column sm={6}>Passwort</Form.Label>
                                <Col sm={6}>
                                    <Form.Control isInvalid={errors.Password && touched.Password} type={passwordShown ? "text" : "password"} placeholder="" name="Password" value={values.Password} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.Password}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group as={Row} className="mb-3" controlId="Passwordrepeat" autoComplete="off">
                                <Form.Label className="required" column sm={6}>Passwort wiederholen</Form.Label>
                                <Col sm={6}>
                                    <Form.Control isInvalid={errors.Passwordrepeat && touched.Passwordrepeat} type={passwordShown ? "text" : "password"} placeholder="" name="Passwordrepeat" value={values.Passwordrepeat} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.Passwordrepeat}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        {/*<Col xs={12}>*/}
                        {/*    <Form.Group className="mb-3" controlId="NewsletterOptIn">*/}
                        {/*        <Form.Check type="checkbox" name="NewsletterOptIn" label="Ich möchte wöchentlich über Termine per Mail informiert werden." value={values.NewsletterOptIn} onChange={handleChange} isInvalid={errors.NewsletterOptIn && touched.NewsletteroptIn} />*/}
                        {/*        {(errors.NewsletteroptIn && touched.NewsletteroptIn) && (*/}
                        {/*            <div className="text-danger">{errors.NewsletterOptIn}</div>*/}
                        {/*        ) }*/}
                        {/*    </Form.Group>*/}
                        {/*</Col>*/}
                        <Col xs={12}>
                            <Form.Group className="mb-3" controlId="ConditionOfUse">
                                <Form.Check className="required" type="checkbox" name="ConditionOfUse" label={<span>Ich akzeptiere die <a target="_blank" href="/nutzungsbedingungen"><u>Nutzungsbedingungen</u>.</a></span>} value={values.ConditionOfUse} onChange={handleChange} isInvalid={errors.ConditionOfUse && touched.ConditionOfUse} />
                                {errors.ConditionOfUse && touched.ConditionOfUse && (
                                    <div className="text-danger">{errors.ConditionOfUse}</div>
                                )}
                            </Form.Group>
                        </Col>
                    </Row>
                                       
                    <Row>
                        <Col xs={12}>
                            Bitte nehmen Sie auch unsere <a target="_blank" href="/datenschutz"><u>Datenschutzerklärung</u></a> zur Kenntnis.
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12} lg={6}>
                            <MandatoryFieldNotice/>
                        </Col>
                        <Col xs={12} lg={6} className="text-right">
                            <Button variant="secondary" type="submit">
                                <i className="fa-solid fa-right-to-bracket mr-2"></i>Registrieren
                            </Button>
                        </Col>
                    </Row>
                </Form>
            )}
        </Formik>
    );
}

export default Register;